(function () {
  'use strict';

  class ExpurgoCtrl {
    constructor($scope, HttpServiceV3g, $uibModal, moment, Uos, UoArvoreNivel, ServiceVfiltro, FactoryVfiltro,
      AlertasEnum, VeiculosDonoService, ConfigEventosService, $translate) {
      this.uoService = Uos;
      this.uoArvoreNivel = UoArvoreNivel;
      this.veiculosService = VeiculosDonoService;
      this.configEventosService = ConfigEventosService;
      this.moment = moment;
      this.scope = $scope;
      this.httpService = HttpServiceV3g;
      this.modalService = $uibModal;

      this.serviceVfiltro = ServiceVfiltro;
      this.translate = $translate;

      this.selecao = {};
      this.uos = [];
      this.veiculos = [];
      this.alertas = [];

      this.limitUos = 10;
      this.limitVeiculos = 10;
      this.limitAlertas = 10;
      this.flagSalvar = false;

      this.todasAsEntidades = false;
      this.placeHolderVeiculos = this.translate.instant('core-permissoes.purge.selectOuLoadVehicle');
      this.alertasTiposExpurgo = AlertasEnum.getTiposExpurgo();

      this.dataInicioValidators = {
        isDataFutura: this.isNotDataFutura(() => this.scope.expurgoForm.dataInicio.$viewValue)
      };
      this.dataFimValidators = {
        isDataFutura: this.isNotDataFutura(() => this.scope.expurgoForm.dataFim.$viewValue),
        isIntervaloValido: this.isIntervaloValido(),
        isIntervaloAte30Dias: this.isIntervaloAte30Dias()
      };
      this.horaInicioValidators = {
        isHoraInicioFuturo: this.isNotHoraInicioFuturo()
      };
      this.horaFimValidators = {
        isHoraFimValida: this.isHoraFimValida(),
        isHoraFimFuturo: this.isNotHoraFimFuturo()
      };

      ServiceVfiltro.init(FactoryVfiltro.get([]))
      .then(() => {
        this.init(this.serviceVfiltro.factoryVfiltro.user);
        this.abonoVisualizar = this.serviceVfiltro.factoryVfiltro.authenticator.hasRole('ABONO_VISUALIZAR');
        this.abonoEditar = this.serviceVfiltro.factoryVfiltro.authenticator.hasRole('ABONO_EDITAR');
      });
    }

    init(user) {
      this.user = user;
      this.carregarUos(this.user.uo.id);
    }

    loadMoreUos() {
      this.limitUos += 10;
    }

    loadMoreVeiculos() {
      this.limitVeiculos += 10;
    }

    loadMoreAlertas() {
      this.limitAlertas += 10;
    }

    podeVerHistoricoAbono() {
      return this.abonoVisualizar;
    }

    goToHist() {
      return `/historico-expurgo?vfiltro=uo:${angular.isDefined(this.user) && this.user.uo.id ? this.user.uo.id : ''}`;
    }

    podeFazerAbono() {
      return this.abonoEditar;
    }

    carregarUos() {
      this.uoService.getFilhas(this.user.uo.id).then(data =>
        this.uos = this.uoArvoreNivel.converterEmLista(data.plain()));
    }

    carregarVeiculos() {
      this.model.veiculo = null;
      this.veiculos = [];
      this.veiculosService.getVeiculos(this.model.uo.id).then(data => {
        this.veiculos = data;
        this.msgVeiculos();
      });
    }

    carregarConfigEventos() {
      this.configEventosService.getConfigEventosPorUo(this.model.uo.id).then(data => {
        this.alertas = this.alertasTiposExpurgo
          .filter(alerta => !data[alerta.descricao.split('.').pop()] || data[alerta.descricao.split('.').pop()].enabled);
      });
    }

    ok() {
      if (this.scope.expurgoForm.$valid) {
        this.modalService.open({
          templateUrl: 'expurgo/confirm-expurgo-modal/confirm-expurgo-modal.tpl.html',
          controller: 'ConfirmExpurgoModalCtrl',
          controllerAs: 'ctrl',
          size: 'md',
          resolve: {
            evento: () => this.model.alerta
          }
        }).result
        .then(() => {
          this.efetuarAbono();
        });
      } else {
        this.flagSalvar = this.scope.expurgoForm.$error.required;
      }
    }

    efetuarAbono() {
      const veiculoId = this.model.veiculo.id,
          tipoEvento = this.model.alerta.id,
          expurgo = {
            justificativa: this.model.justificativa,
            inicio: this.getDatahoraInicio().toISOString(),
            fim: this.getDatahoraFim().toISOString()
          };
      this.httpService.post(`/expurgo/expurgos/veiculo/${veiculoId}/tipo-evento/${tipoEvento}`, expurgo)
        .then(
          () => {
            this.limpaCampos();
            this.alert = {
              display: true,
              alertClass: 'alert-success',
              alertMessage: this.translate.instant('core-permissoes.purge.dismissalRequest')
            };
          },
          error => {
            if (error.status === 400 && error.data.message === 'Nenhum histórico de veículo encontrado.') {
              this.alert = {
                display: true,
                alertClass: 'alert-danger',
                alertMessage: this.translate.instant('core-permissoes.purge.noHistoryFoundVehicle')
              };
            } else {
              this.alert = {
                display: true,
                alertClass: 'alert-danger',
                alertMessage: this.translate.instant('core-permissoes.purge.errorRequest')
              };
            }
          }
        );
    }

    limpaCampos() {
      this.model = {};
      this.scope.expurgoForm.$setPristine();
    }

    msgVeiculos() {
      if (!this.model.uo) {
        this.placeHolderVeiculos = this.translate.instant('core-permissoes.purge.selectOuLoadVehicle');
      }
      if (!this.veiculos.length) {
        this.placeHolderVeiculos = this.translate.instant('core-permissoes.purge.noVehiclesOu');
      } else {
        this.placeHolderVeiculos = this.translate.instant('core-permissoes.purge.selectVehicleDismiss');
      }
    }

    isNotDataFutura(dateSupplier) {
      return () => {
        let dataInput = this.moment(dateSupplier());
        if (dataInput.isValid()) {
          let dataValidation = dataInput.isBefore(this.moment().endOf('day'));
          if (dataValidation) {
            this.scope.expurgoForm.horaInicio.$validate();
            this.scope.expurgoForm.horaFim.$validate();
          }
          return dataValidation;
        }
        return true;
      };
    }

    isIntervaloValido() {
      return () => {
        let inicio = this.moment(this.scope.expurgoForm.dataInicio.$viewValue, 'YYYY-MM-DD', true),
            fim = this.moment(this.scope.expurgoForm.dataFim.$viewValue, 'YYYY-MM-DD', true);
        if (inicio.isValid() && fim.isValid()) {
          return inicio.isSameOrBefore(fim);
        }
        return true;
      };
    }

    isIntervaloAte30Dias() {
      const TRINTA_DIAS_MS = 30 * 24 * 60 * 60 * 1000;
      return () => {
        let inicio = this.getDatahoraInicio(),
            fim = this.getDatahoraFim();
        if (inicio.isValid() && fim.isValid() && inicio.isSameOrBefore(fim)) {
          return fim.diff(inicio) < TRINTA_DIAS_MS;
        }
        return true;
      };
    }

    isNotHoraInicioFuturo() {
      return () => {
        return !this.getDatahoraInicio().isAfter(this.moment());
      };
    }

    isNotHoraFimFuturo() {
      return () => {
        return !this.getDatahoraFim().isAfter(this.moment());
      };
    }

    isHoraFimValida() {
      return () => {
        let inicio = this.getDatahoraInicio(),
            fim = this.getDatahoraFim();
        if (inicio.date() === fim.date() && inicio.month() === fim.month() && inicio.year() === fim.year()) {
          return inicio.isBefore(fim);
        }
        return true;
      };
    }

    isValidJustificativa() {
      return () => {
        let justificativa = this.scope.expurgoForm.justificativa.$viewValue;
        if (angular.isDefined(justificativa)) {
          return justificativa.replace(/\s/g, '').length >= 5;
        }
        return true;
      };
    }

    isEmpty(field) {
      return this.flagSalvar && field.$error.required;
    }

    isDataFinalInvalid() {
      let horaFim = this.scope.expurgoForm.horaFim;
      return horaFim.$dirty && horaFim.$invalid || this.isEmpty(horaFim);
    }

    getDatahoraInicio() {
      const horaNormalizada = this.normalizarHora(this.scope.expurgoForm.horaInicio.$viewValue);
      return this.moment(
        `${this.scope.expurgoForm.dataInicio.$viewValue} ${horaNormalizada}`,
        'YYYY-MM-DD HH:mm:ss',
        true
      );
    }

    getDatahoraFim() {
      const horaNormalizada = this.normalizarHora(this.scope.expurgoForm.horaFim.$viewValue);
      return this.moment(
        `${this.scope.expurgoForm.dataFim.$viewValue} ${horaNormalizada}`,
        'YYYY-MM-DD HH:mm:ss',
        true
      );
    }

    normalizarHora(horaStr) {
      if (horaStr) {
        const [hora, minuto, segundo] = horaStr.split(':');
        if (hora && minuto && segundo) {
          return `${hora}:${minuto}:${segundo}`;
        } else if (hora && minuto) {
          return `${hora}:${minuto}:00`;
        }
      }
      return '00:00:00';
    }

    hasError(formField) {
      if (formField) {
        return !!formField.$dirty && !!formField.$invalid;
      }
    }

    validarCamposDataHora() {
      this.scope.expurgoForm.dataInicio.$validate();
      this.scope.expurgoForm.horaInicio.$validate();
      this.scope.expurgoForm.dataFim.$validate();
      this.scope.expurgoForm.horaFim.$validate();
    }
  }

  /**
   * @ngdoc object
   * @name expurgo.controller:ExpurgoCtrl
   *
   * @description
   *
   */
  angular
    .module('expurgo')
    .controller('ExpurgoCtrl', ExpurgoCtrl);
}());
